/** Older settings tabs still send this key. It no longer affects routing. */
export function omitRetiredAiTicketVolume(input: unknown): unknown {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    return input;
  }
  if (!Object.hasOwn(input, "support/ai/aiAutopilotTicketVolume")) {
    return input;
  }
  return Object.fromEntries(
    Object.entries(input).filter(
      ([key]) => key !== "support/ai/aiAutopilotTicketVolume",
    ),
  );
}
